import * as React from "react";

const Groups = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M9.00098 10C11.2101 10 13.001 8.20914 13.001 6C13.001 3.79086 11.2101 2 9.00098 2C6.79184 2 5.00098 3.79086 5.00098 6C5.00098 8.20914 6.79184 10 9.00098 10Z"
      fill={props.color || '#5B7B82'}
    />
    <path
      d="M9.00098 21.001C12.867 21.001 16.001 19.2101 16.001 17.001C16.001 14.7918 12.867 13.001 9.00098 13.001C5.13498 13.001 2.00098 14.7918 2.00098 17.001C2.00098 19.2101 5.13498 21.001 9.00098 21.001Z"
      fill={props.color || '#5B7B82'}
    />
    <path
      d="M21.0002 16.9997C21.0002 18.6567 18.9642 19.9997 16.4792 19.9997C17.2112 19.1997 17.7152 18.1947 17.7152 17.0017C17.7152 15.8067 17.2102 14.8017 16.4762 14.0007C18.9622 13.9997 21.0002 15.3437 21.0002 16.9997ZM18.0002 5.99965C18.0005 6.48237 17.8843 6.95803 17.6616 7.38626C17.4388 7.81449 17.1159 8.18263 16.7205 8.45943C16.325 8.73623 15.8686 8.91351 15.3899 8.97622C14.9113 9.03893 14.4246 8.98522 13.9712 8.81965C14.4592 7.95998 14.7152 6.98818 14.7142 5.99965C14.7142 4.97465 14.4442 4.01265 13.9722 3.18065C14.4256 3.01528 14.9121 2.96173 15.3906 3.02454C15.8691 3.08735 16.3254 3.26467 16.7207 3.54144C17.1161 3.81822 17.4388 4.18628 17.6615 4.6144C17.8843 5.04252 18.0005 5.51706 18.0002 5.99965Z"
      fill={props.color || '#5B7B82'}
    />
  </svg>
);

export default Groups;






